import type React from 'react';

interface ModalScaffoldProps {
  /** When true, the scaffold fills the screen on top of everything else. */
  open: boolean;
  children: React.ReactNode;
  className?: string;
}

/**
 * Presentational overlay that renders its children on top of the app when `open`.
 * Structure/styling only — dimmed full-viewport backdrop shell (card chrome is owned by the consumer).
 */
const ModalScaffold = ({ open, children, className = '' }: ModalScaffoldProps) => {
  if (!open) {
    return null;
  }

  return (
    <div className={`modal-scaffold ${className}`.trim()} role="presentation">
      <div className="modal-scaffold__surface">{children}</div>
    </div>
  );
};

export default ModalScaffold;
